define([
    './LoadingIndicationDirective',
    './CallTrackerService',
], (LoadingIndicationDirective, CallTrackerService)=> {
    return angular.module('edge.platform.widgets.loadingMsg', [])
        .factory('CallTrackerService', CallTrackerService)
        .directive('gwPlLoadingMsg', LoadingIndicationDirective);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/loading/module.js